function Card({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-white rounded-[12px] shadow-md shadow-brand/10 overflow-hidden mb-8 px-2 md:px-[20px] py-[20px] border border-brand/30">
      {children}
    </div>
  );
}

export default Card;
